export const IMAGE_TYPE_PRODUCT = 'product_image';
export const IMAGE_TYPE_STOCK = 'stock_image';
export const IMAGE_TYPE_FILES = 'files';
export const IMAGE_TYPE_DOWNLOAD = 'download';